import { i18n, lang } from '../../unit/const'
export default {
  name: 'Decorate',
  computed: {
    title: () => i18n.title[lang],
    blog: () => i18n.blog[lang],
    QRTitle: () => i18n.QRNotice[lang],
    QRCode: () => i18n.QRCode[lang]
  }
}



// WEBPACK FOOTER //
// ./src/components/decorate/index.js